// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"ArrayFieldItemTemplate_itemContainer__1f-K7","removeBtn":"ArrayFieldItemTemplate_removeBtn__1ZYEq"};